import React from 'react'

//
import { Statistics } from '../../../storybook'
import { THEME } from '@/src/utils/common'

const BlockBenefitsListing = ({ data: { benefits = [], theme } }) => {
  return <Statistics statistics={benefits} theme={theme || THEME.light} />
}

export default BlockBenefitsListing
